<template>
  <header class="mdc-toolbar mdc-elevation--z2">
    <div class="mdc-toolbar__row">
      <section class="mdc-toolbar__section mdc-toolbar__section--align-start">
        <!--<a href="#" class="material-icons mdc-toolbar__icon&#45;&#45;menu">menu</a>-->
        <span class="mdc-toolbar__title">
           <span class="mdc-typography--headline">Ajay Addepalle</span>
        </span>
      </section>
    </div>
    <div class="mdc-toolbar__row">
      <section class="mdc-toolbar__section">
        <span class="mdc-toolbar__title">
          <router-link to="/" class="mdc-typography--button">Home</router-link>
        </span>
        <span class="mdc-toolbar__title">
          <router-link to="/blog" class="mdc-typography--button">Blog</router-link>
        </span>
        <span class="mdc-toolbar__title">
          <router-link to="/contact" class="mdc-typography--button">Contact</router-link>
        </span>
      </section>
    </div>
  </header>
</template>

<script>
  export default {}
</script>

<style lang="scss" scoped>
  @import '~@material/toolbar/mdc-toolbar';
</style>



// WEBPACK FOOTER //
// Navbar.vue?16737310